import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_TextInput } from '../../../../../../../design/inputs/textInput/S_TextInput';
interface IProps {
  searchText: string;
  onSearchChange: (text: string) => Promise<void>;
}

export const ImageNameSearch = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_TextInput
      className='search-images-input'
      value={props.searchText}
      placeholder={t('search_image_name')}
      onChange={(val) => {
        void props.onSearchChange(val);
      }}
    />
  );
});
